import React from 'react';

const ResponseViewer = ({ responses, onPageChange }) => {
  const { data, page, pages } = responses;

  if (!data.length) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>No responses yet. Results will appear here after the next scheduled run.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {data.map((r) => (
        <div key={r.id} className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="text-xs text-gray-400 mb-2">
            {new Date(r.run_time).toLocaleString()}
          </div>
          <pre className="text-sm text-gray-800 whitespace-pre-wrap break-words leading-relaxed font-sans">
            {r.response_text}
          </pre>
        </div>
      ))}

      {pages > 1 && (
        <div className="flex items-center justify-center gap-3 py-4 text-sm text-gray-500">
          <button
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 transition"
          >
            Previous
          </button>
          <span>Page {page} of {pages}</span>
          <button
            disabled={page >= pages}
            onClick={() => onPageChange(page + 1)}
            className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 transition"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ResponseViewer;
